import { useState } from "react";

import { DotsLoader } from "@similarweb/ui-components";

import { useDidUpdate } from "app/custom-hooks/useDidUpdate";

import { StyledAutoHiddenElement, StyledDotsLoaderContainer, StyledFlexContainer, StyledSuccessIcon } from "./styles";
import type { ProcessStatus } from "./types";

type Props = {
    isLoading: boolean;
    error?: string;
};

const LoaderWithProcessStatus = (props: Props) => {
    const [status, setStatus] = useState<ProcessStatus | null>(null);

    useDidUpdate(() => {
        if (props.isLoading) {
            setStatus("loading");
            return;
        }

        if (typeof props.error === "undefined") {
            setStatus("success");
            return;
        }

        setStatus("error");
    }, [props.isLoading, props.error]);

    const handleResetStatus = () => {
        setStatus(null);
    };

    const renderStatus = () => {
        switch (status) {
            case "loading":
                return (
                    <StyledDotsLoaderContainer>
                        <DotsLoader />
                    </StyledDotsLoaderContainer>
                );

            case "success":
                return (
                    <StyledAutoHiddenElement onAnimationEnd={handleResetStatus}>
                        <StyledSuccessIcon
                            iconName="checked-circle"
                            size="sm"
                        />
                    </StyledAutoHiddenElement>
                );

            case "error":
                return null;
        }
    };

    return status ? <StyledFlexContainer>{renderStatus()}</StyledFlexContainer> : null;
};

export default LoaderWithProcessStatus;
